export const PRESS_STATS_DATA_ID = 'press-stats-data'
export const PRESS_STATS_URL = 'https://data.ulule.com/stats.json'

export type PressStats = {
  amountRaisedEur: number
  projectsSuccessCount: number
  updatedAt: string
  usersCount: number
}

type SourceStats = {
  amount_raised?: { EUR?: unknown }
  projects_success_count?: unknown
  users_count?: unknown
}

export function parsePressStats(source: unknown, updatedAt: string): PressStats | null {
  if (typeof source !== 'object' || source === null) return null

  const normalizedUpdatedAt = normalizeDate(updatedAt)
  if (normalizedUpdatedAt === null) return null

  const sourceStats = source as SourceStats
  const stats = {
    amountRaisedEur: sourceStats.amount_raised?.EUR,
    projectsSuccessCount: sourceStats.projects_success_count,
    updatedAt: normalizedUpdatedAt,
    usersCount: sourceStats.users_count,
  }

  return isPressStats(stats) ? stats : null
}

export function isPressStats(value: unknown): value is PressStats {
  if (typeof value !== 'object' || value === null) return false

  const stats = value as Record<string, unknown>
  return (
    isNonNegativeNumber(stats.amountRaisedEur) &&
    isNonNegativeNumber(stats.projectsSuccessCount) &&
    isValidDate(stats.updatedAt) &&
    isNonNegativeNumber(stats.usersCount)
  )
}

function isNonNegativeNumber(value: unknown): value is number {
  return typeof value === 'number' && Number.isFinite(value) && value >= 0
}

function isValidDate(value: unknown): value is string {
  return typeof value === 'string' && !Number.isNaN(Date.parse(value))
}

function normalizeDate(value: string): string | null {
  const timestamp = Date.parse(value)
  return Number.isNaN(timestamp) ? null : new Date(timestamp).toISOString()
}
